import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { InsurancePremiumsStyled } from '../../../asset/styled/deductions/InsurancePremiumsStyled';
import titleImg from '../../../asset/img/insurance_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';
import InsuranceItemSection from './InsuranceItemSection';
import TotalSection from '../../../components/TotalSection';
import InsuranceDetail from './detail';

const InsurancePremiums = () => {
  const { t } = useTranslation('deductions/insurance');
  const { total } = useSelector(state => state.insurance);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <InsurancePremiumsStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />

      <InsuranceItemSection onOpen={handleOpen} />
      {/* 합계 */}
      <TotalSection total={total} />

      {/* 상세 slide */}
      <InsuranceDetail isOpen={isOpen} onClose={handleClose} />
    </InsurancePremiumsStyled>
  );
};

export default InsurancePremiums;
